<template>
  <div>
    <RegisterForm/>
    <SidebarImage />
  </div>
</template>

<script>
import RegisterForm from '@/components/Auth/RegisterForm'
import SidebarImage from '@/components/SideBar/SidebarImage.vue'

export default {
  name: 'RegisterView',
  components: { RegisterForm, SidebarImage }
}
</script>

<style scoped>
</style>
